// ISDP CUSTOM — i18n "auth" namespace: sign-in screen, 404 error page, and the
// role-routing splash. See ./common.ts for the convention.
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const authMessages = createTranslationRef({
  id: 'devhub.auth',
  messages: {
    signIn: {
      signingYouIn: 'Signing you in…',
      welcomeBack: 'Welcome back',
      subtitle: 'Sign in with your Dräger account to continue.',
      // {provider} = "Dräger" or "Microsoft"
      button: 'Sign in with {{provider}}',
      signingIn: 'Signing in…',
      hintDraeger: 'Use your Dräger account. Access is provisioned by your team.',
    },
    notFound: {
      title: 'This page took a different path',
      desc: "The page you're looking for doesn't exist, moved, or you don't have access. Let's get you back on track.",
      backHome: 'Back to Home',
      goBack: 'Go back',
    },
    splash: {
      loadingWorkspace: 'Loading your workspace…',
    },
    // Shown to a signed-in user who has no internal access, in a release where the
    // external Partner Portal is not shipped (see isdp-common/release.ts).
    noAccess: {
      title: 'The DevHub is for Dräger teams',
      desc: "It's an internal platform for Dräger's development teams. If you're a Dräger employee who needs access, contact your Dräger representative to get set up.",
      signOut: 'Sign out',
    },
  },
  translations: {
    de: () => import('./de/auth'),
  },
});
